// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"4b523e74","355":"948f80fc","633":"c67cd0b8"}[chunkId] + ".chunk.js";
};